module.exports = __webpack_public_path__ + "img/便利店、超市.0faa09db.jpg";